import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M19.47 8.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5m0-4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M2.665 23.254a4.31 4.31 0 1 0 4.79-7.168 4.31 4.31 0 0 0-4.79 7.168m.834-5.92a2.81 2.81 0 1 1 3.122 4.672A2.81 2.81 0 0 1 3.5 17.334M16.545 23.254a4.3 4.3 0 0 0 2.395.726 4.32 4.32 0 0 0 4.31-4.31 4.31 4.31 0 1 0-6.705 3.584m.834-5.92a2.81 2.81 0 1 1 3.122 4.672 2.81 2.81 0 0 1-3.122-4.672"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.409 21.701a2.25 2.25 0 0 0 3.84-1.591V17a1.74 1.74 0 0 0-.2-.82l-1.71-3.32a.26.26 0 0 1 .09-.34l.92-.53a.25.25 0 0 1 .33.08l.51.91a2.73 2.73 0 0 0 2.4 1.42h2.88a2.25 2.25 0 1 0 0-4.5h-1.65a.22.22 0 0 1-.21-.12l-1.27-2.2a2.77 2.77 0 0 0-3.76-1L8.31 9.05a2.76 2.76 0 0 0-1 3.76l2.27 3.88c.111.192.17.409.17.63v2.79c0 .597.238 1.169.66 1.591m2.97-13.871c.19-.105.404-.16.62-.16a1.25 1.25 0 0 1 1.05.62l1.27 2.2a1.74 1.74 0 0 0 1.51.87h1.64a.75.75 0 1 1 0 1.5h-2.89a1.24 1.24 0 0 1-1.09-.64l-.51-.93a1.76 1.76 0 0 0-2.39-.64l-.92.53a1.75 1.75 0 0 0-.67 2.33l1.75 3.33a.3.3 0 0 1 0 .12v3.15a.75.75 0 1 1-1.5 0v-2.79c0-.484-.127-.96-.37-1.38l-2.27-3.93a1.25 1.25 0 0 1 .46-1.71z"
      clipRule="evenodd"
    />
  </>
);

const BikingRoad = Icon('biking-road', svgContents);

export default BikingRoad;
